import { memo } from 'react'
import { CheckboxInput } from 'types/input'

const Checkbox = ({
  label,
  value = '',
  name,
  checked,
  onSelect,
  disabled,
  CbRef,
  col,
  ...props
}: CheckboxInput) => {
  return (
    <div
      key={value}
      className={`flex w-full items-center justify-start gap-2 ${
        disabled && 'opacity-50'
      } ${col === 1 && 'flex-row-reverse justify-between'}`}
    >
      <input
        id={value}
        name={name}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onSelect}
        className="h-4 w-4 shrink-0 rounded-lg accent-black"
        disabled={disabled}
        ref={CbRef}
        {...props}
      />

      <label
        htmlFor={value}
        className="truncate text-xs font-semibold text-gray-600"
      >
        {label}
      </label>
    </div>
  )
}
export default memo(Checkbox)
